import { Link } from 'react-router-dom';
import infoSvg from 'assets/icons/info.svg';
import Modal, { ModalProps, ModalSize } from 'lib/Modal';
import Card, { CardTheme } from 'lib/Card';
import Button from 'lib/Button';
import SvgIcon from 'lib/SvgIcon';
import { useExportJob } from '../hooks/useExportJob';
import { ExportJobCard } from '../ExportJobCard/ExportJobCard';

export const ExportAssetDataPanel = ({ onClose }: Partial<ModalProps>): React.ReactElement => {
  const { jobHistory, isExportDisabled, generateExport } = useExportJob();

  return (
    <Modal
      isOpen
      title="Export Asset Data"
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onClose={onClose}
      size={ModalSize.MEDIUM}
      actionButtons={
        <div className="flex space-x-2">
          <div className="py-0.5">
            <SvgIcon src={infoSvg} className="w-5 h-5" />
          </div>
          <p className="body-lg text-neutral-900">
            The downloaded asset data mirrors exactly what is shared with DSPs. It excludes assets missing PMP_CPT,
            assets with zero width/height, assets without active offers, and assets dismounted on the day of the
            request. Please refer to the{' '}
            <Link to="/inventory-management/asset-health" className="sub-header-lg text-primary-600">
              Asset Health Dashboard
            </Link>{' '}
            for more details.
          </p>
        </div>
      }
    >
      <div className="space-y-4">
        <Card theme={CardTheme.TRANSPARENT_WITH_BORDER}>
          <div className="p-2.5 flex flex-col space-y-4">
            <div className="flex flex-col space-y-1">
              <p className="sub-header-base">New export</p>
              <p className="body-base text-neutral-900">Generate a fresh CSV export of your current asset data</p>
            </div>
            <div>
              <Button label="Generate export" onClick={generateExport} isDisabled={isExportDisabled} />
            </div>
          </div>
        </Card>
        {!!jobHistory.length && (
          <Card theme={CardTheme.TRANSPARENT_WITH_BORDER}>
            <div className="p-2.5 flex flex-col space-y-4">
              <div className="flex flex-col space-y-1">
                <p className="sub-header-base">Export history</p>
                <p className="body-base text-neutral-900">View your previous exports and re-download completed files</p>
              </div>
              <div className="flex flex-col space-y-2 max-h-[450px] overflow-y-scroll">
                {jobHistory.map((job) => (
                  <ExportJobCard job={job} key={job.jobId} />
                ))}
              </div>
            </div>
          </Card>
        )}
      </div>
    </Modal>
  );
};
